export default __webpack_public_path__ + "static/media/collapse.07d2d27d.svg";